const NUVEM_PAGO_COMMONS_URL = '/v1/nuvem-pago-commons';
export const KYC_STATUS_URL = `${NUVEM_PAGO_COMMONS_URL}/kyc/status`;
export const NUVEM_PAGO_FEATURE_FLAG_URL = `${NUVEM_PAGO_COMMONS_URL}/feature-flags/:flag`;
export const EVALUATION_RESULT_URL = `${NUVEM_PAGO_COMMONS_URL}/feature-flags/evaluation-result/:flag`;
